import { CardType } from '@scale/genai-compass-shared/cardTypes';
import type { CompassCardUI } from '@scale/compass-ui/types';
import { coreCardUIs } from '@scale/compass-ui/cards';
import type { genaiCards } from '@scale/genai-compass-shared/cards';
import { blankCardUI } from './blankCardUI';

import { PercentageCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/transformation/PercentageCard/constants';
import { UpdateCourseProgressV2CardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/UpdateCourseProgressV2Card/constants';
import { SnowflakeSqlCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/adapter/SnowflakeSqlCard/constants';
import { ExplainQueueCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/transformation/ExplainQueueCard/constants';
import { ContributorsAdapterCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/adapter/ContributorsAdapterCard/card';
import { ContributorScreeningsAdapterCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/adapter/ContributorScreeningsAdapterCard/constants';
import { GroupByCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/transformation/GroupByCard/constants';
import { TaskActionsCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/TaskActions/constants';
import { TagActionsCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/TagActions/constants';
import { TagUntagUsersCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/TagUntagUsersCard/constants';
import { EditWorkerSkillEntryCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/EditWorkerSkillEntryCard/constants';
import { UpdateDirectAssignmentCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/UpdateDirectAssignmentCard/constants';
import { OptInNotificationCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/transformation/OptInNotificationCard/constants';
import { JoinContributorCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/transformation/JoinContributorData/constants';
import { ArchieQCResultsAdapterCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/adapter/ArchieQCResultsAdapterCard/constants';
import { ModelEvalCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/transformation/ModelEvalCard/constants';
import { ModelEvalV2CardUIOverride } from 'react-scale/corp/views/DataCompassCardsV2/transformation/ModelEvalV2Card/constants';
import { AutoreviewerResultsAdapterCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/adapter/AutoreviewerResultsAdapterCard/constants';
import { LinterCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/transformation/LinterCard/constants';
import { ManuallyPrioritiseTasksCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/ManuallyPrioritiseTasksCard/constants';
import { PromptDiversityCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/transformation/PromptDiversity/constants';
import { ChatBulkAuditResultsCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/adapter/ChatBulkAuditResultsCard/constants';
import { TaskResponseCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/transformation/TaskResponseCard/constants';
import { CDSResponseDownloadCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/transformation/CDSResponseDownloadCard/constants';
import { UpdateMetadataCardInput } from 'react-scale/corp/views/DataCompassCardsV2/action/UpdateMetadataCard/constants';
import { JoinCardInput } from 'react-scale/corp/views/DataCompassCardsV2/transformation/JoinCard/WorkerId/constants';
import { WorkerTeamAdapterCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/adapter/WorkerTeamAdapterCard/constants';
import { TransformScriptCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/TransformScriptCard/constants';
import { CdsUploadCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/CdsUploadCard/constants';
import { UpdateReferralRatesCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/UpdateReferralRatesCard/constants';
import { ChatBulkAuditCardInput } from 'react-scale/corp/views/DataCompassCardsV2/action/ChatBulkAudit/constants';
import { ResolveDisputesCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/ResolveDisputesCard/constants';
import { SphereEngineExecutionCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/transformation/SphereEngineExecutionCard/constants';
import { VellumCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/transformation/VellumCard/constants';
import { ExportToGoogleSheetsCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/ExportToGoogleSheetsCard/constants';
import { PassAtKCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/transformation/PassAtK/constants';
import { CommunicationsCenterSendCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/CommunicationCenterCard/constants';
import { SquadActionsCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/SquadActionsCard/constants';
import { SaveToSnowflakeCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/SaveToSnowflakeCard/constants';
import { ModalExecutionCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/transformation/ModalExecutionCard/constants';
import { TranscribeAudioCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/TranscribeAudioCard/constants';
import { TaskAdapterCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/adapter/TaskAdapterCard/constants';
import { MoveWorkerTeamCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/MoveWorkerTeamCard/constants';
import { HubstaffMemberActionsCardInput } from 'react-scale/corp/views/DataCompassCardsV2/action/HubstaffMemberActionsCard/constants';
import { CalendarDataGeneratorCardInput } from 'react-scale/corp/views/DataCompassCardsV2/action/CalendarDataGeneratorCard/constants';
import { ResponseBackfillCardInfo } from 'react-scale/corp/views/DataCompassCardsV2/action/ResponseBackfillCard/constants';

// Auto ops
import { AddReviewerPermissionsCardUI } from 'react-scale/corp/views/DataCompassCardsV2/action/GenericAutoOpsCard/cards/add_reviewer_permissions';
import { AddUsersToMultipleTagsCardUI } from 'react-scale/corp/views/DataCompassCardsV2/action/GenericAutoOpsCard/cards/add_users_to_multiple_tags';
import { DemoteReviewersCardUI } from 'react-scale/corp/views/DataCompassCardsV2/action/GenericAutoOpsCard/cards/demote_reviewers';
import { DisableTaskersCardUI } from 'react-scale/corp/views/DataCompassCardsV2/action/GenericAutoOpsCard/cards/disable_taskers';
import { RemoveUsersFromMultipleTagsCardUI } from 'react-scale/corp/views/DataCompassCardsV2/action/GenericAutoOpsCard/cards/remove_users_from_multiple_tags';
import { TagUsersDynamicCardUI } from 'react-scale/corp/views/DataCompassCardsV2/action/GenericAutoOpsCard/cards/tag_users_dynamic';

// Card constructors
import { FilterCardUI } from '@scale/compass-ui/cards/filter/card';
import { COLUMN_ID_TO_OPTIONS } from 'react-scale/corp/views/DataCompassCardsV2/components/filters/inputFilterOptions';
import { createGoogleSheetsCardUI } from '@scale/compass-ui/cards/google_sheets/card';
import { GOOGLE_SHEETS_SERVICE_ACCOUNT } from '@scale/genai-compass-shared/services/googleSheets';

const filterCard = FilterCardUI(COLUMN_ID_TO_OPTIONS);
const googleSheetsCardUI = createGoogleSheetsCardUI(GOOGLE_SHEETS_SERVICE_ACCOUNT);

export const genAICardUIs = {
  ...coreCardUIs,
  [googleSheetsCardUI.cardType]: googleSheetsCardUI,
  [TaskAdapterCardInfo.cardType]: TaskAdapterCardInfo,
  [MoveWorkerTeamCardInfo.cardType]: MoveWorkerTeamCardInfo,
  [filterCard.cardType]: filterCard,
  [PercentageCardInfo.cardType]: PercentageCardInfo,
  [UpdateCourseProgressV2CardInfo.cardType]: UpdateCourseProgressV2CardInfo,
  [SnowflakeSqlCardInfo.cardType]: SnowflakeSqlCardInfo,
  [ExplainQueueCardInfo.cardType]: ExplainQueueCardInfo,
  [ContributorsAdapterCardInfo.cardType]: ContributorsAdapterCardInfo,
  [ContributorScreeningsAdapterCardInfo.cardType]: ContributorScreeningsAdapterCardInfo,
  [GroupByCardInfo.cardType]: GroupByCardInfo,
  [WorkerTeamAdapterCardInfo.cardType]: WorkerTeamAdapterCardInfo,
  [SphereEngineExecutionCardInfo.cardType]: SphereEngineExecutionCardInfo,
  [ModalExecutionCardInfo.cardType]: ModalExecutionCardInfo,
  [TaskActionsCardInfo.cardType]: TaskActionsCardInfo,
  [TagActionsCardInfo.cardType]: TagActionsCardInfo,
  [TagUntagUsersCardInfo.cardType]: TagUntagUsersCardInfo,
  [EditWorkerSkillEntryCardInfo.cardType]: EditWorkerSkillEntryCardInfo,
  [UpdateReferralRatesCardInfo.cardType]: UpdateReferralRatesCardInfo,
  [UpdateDirectAssignmentCardInfo.cardType]: UpdateDirectAssignmentCardInfo,
  [OptInNotificationCardInfo.cardType]: OptInNotificationCardInfo,
  [JoinContributorCardInfo.cardType]: JoinContributorCardInfo,
  [ArchieQCResultsAdapterCardInfo.cardType]: ArchieQCResultsAdapterCardInfo,
  [ModelEvalCardInfo.cardType]: ModelEvalCardInfo,
  [ModelEvalV2CardUIOverride.cardType]: ModelEvalV2CardUIOverride,
  [AutoreviewerResultsAdapterCardInfo.cardType]: AutoreviewerResultsAdapterCardInfo,
  [LinterCardInfo.cardType]: LinterCardInfo,
  [ManuallyPrioritiseTasksCardInfo.cardType]: ManuallyPrioritiseTasksCardInfo,
  [PromptDiversityCardInfo.cardType]: PromptDiversityCardInfo,
  [ChatBulkAuditCardInput.cardType]: ChatBulkAuditCardInput,
  [ChatBulkAuditResultsCardInfo.cardType]: ChatBulkAuditResultsCardInfo,
  [TaskResponseCardInfo.cardType]: TaskResponseCardInfo,
  [CDSResponseDownloadCardInfo.cardType]: CDSResponseDownloadCardInfo,
  [UpdateMetadataCardInput.cardType]: UpdateMetadataCardInput,
  [JoinCardInput.cardType]: JoinCardInput,
  [TransformScriptCardInfo.cardType]: TransformScriptCardInfo,
  [CdsUploadCardInfo.cardType]: CdsUploadCardInfo,
  [ResolveDisputesCardInfo.cardType]: ResolveDisputesCardInfo,
  [VellumCardInfo.cardType]: VellumCardInfo,
  [ExportToGoogleSheetsCardInfo.cardType]: ExportToGoogleSheetsCardInfo,
  [CommunicationsCenterSendCardInfo.cardType]: CommunicationsCenterSendCardInfo,
  [SquadActionsCardInfo.cardType]: SquadActionsCardInfo,
  [PassAtKCardInfo.cardType]: PassAtKCardInfo,
  [SaveToSnowflakeCardInfo.cardType]: SaveToSnowflakeCardInfo,
  [TranscribeAudioCardInfo.cardType]: TranscribeAudioCardInfo,
  [HubstaffMemberActionsCardInput.cardType]: HubstaffMemberActionsCardInput,
  [CalendarDataGeneratorCardInput.cardType]: CalendarDataGeneratorCardInput,
  [ResponseBackfillCardInfo.cardType]: ResponseBackfillCardInfo,

  // Auto Ops cards
  [AddUsersToMultipleTagsCardUI.cardType]: AddUsersToMultipleTagsCardUI,
  [RemoveUsersFromMultipleTagsCardUI.cardType]: RemoveUsersFromMultipleTagsCardUI,
  [DisableTaskersCardUI.cardType]: DisableTaskersCardUI,
  [AddReviewerPermissionsCardUI.cardType]: AddReviewerPermissionsCardUI,
  [DemoteReviewersCardUI.cardType]: DemoteReviewersCardUI,
  [TagUsersDynamicCardUI.cardType]: TagUsersDynamicCardUI,

  // Adding missing cards with blankCardUI
  [CardType.ADD_CARD]: blankCardUI,
  [CardType.TABLE]: blankCardUI,
  [CardType.IMPORT_CORP_JOB]: blankCardUI,
  [CardType.TRANSFORM_JSON]: blankCardUI,
  [CardType.MAP_COLUMN]: blankCardUI,
  [CardType.TASKER_QUALITY_DATA_ADAPTER]: blankCardUI,
  [CardType.CONSTANT_ADAPTER]: blankCardUI,
  [CardType.NOOP_ACTION]: blankCardUI,
  [CardType.MOVE_TASKS]: blankCardUI,
  [CardType.QUARANTINE_TASKS]: blankCardUI,
  [CardType.NEW_QA_OPERATION_PER_USER]: blankCardUI,
  [CardType.CANCEL_QA_OPERATIONS]: blankCardUI,
  [CardType.ADD_ATTEMPTER_PERMISSIONS]: blankCardUI,
  [CardType.UPDATE_PLAYGROUND_MINER_FEATURE_STORE]: blankCardUI,
  [CardType.CLASSIFY_PROMPTS]: blankCardUI,
} as const satisfies Record<keyof typeof genaiCards, CompassCardUI<any>>;
